
export default {
    'reservation-stepper-step_1': 'Choose date',
    'reservation-stepper-step_2': 'Choose from available tickets',
    'reservation-stepper-step_3': 'Personal details and payment method',
    'reservation-stepper-total-label': 'Total',
    'reservation-stepper-purchase': 'Purchase',
    'reservation-stepper-submit': 'Reservation'
};
